// Under the api's 4,000 because the browser, Dart and Ruby can count emoji and combined characters differently.
export const MESSAGING_CONTENT_LIMIT = 3_950;

const COUNTER_SHOWN_FROM_FRACTION = 0.9;

const COUNTER_THRESHOLD = MESSAGING_CONTENT_LIMIT * COUNTER_SHOWN_FROM_FRACTION;

export const isMessageTooLong = (content: string) =>
  content.length > MESSAGING_CONTENT_LIMIT;

export const showsMessageLengthCounter = (content: string) =>
  content.length > COUNTER_THRESHOLD;
